var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 7.77778,
    fill: "#87CBFE",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 8.16732C19.3453 8.16732 21.1498 8.71471 22.6847 9.74027C24.2195 10.7658 25.4158 12.2235 26.1222 13.9289C26.8286 15.6344 27.0135 17.511 26.6533 19.3215C26.2932 21.132 25.4043 22.795 24.099 24.1003C22.7937 25.4056 21.1307 26.2945 19.3202 26.6546C17.5097 27.0148 15.6331 26.8299 13.9276 26.1235C12.2222 25.4171 10.7645 24.2208 9.73897 22.686C8.71341 21.1511 8.16602 19.3466 8.16602 17.5006C8.17316 15.0275 9.15878 12.6577 10.9076 10.9089C12.6564 9.16008 15.0262 8.17446 17.4993 8.16732Z",
    stroke: "#87CBFE",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.499 21.2334V16.5667",
    stroke: "#87CBFE",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4951 13.7676H17.504",
    stroke: "#87CBFE",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBg);
export default __webpack_public_path__ + "static/media/info-bg.a6d150621b185212d3d066234ebea9cd.svg";
export { ForwardRef as ReactComponent };